'use client';
import type { RefObject } from 'react';
import { useEffect, useRef } from 'react';

import { useOnClickOutside } from '~components/Popup/hooks';
import { useDelayedPreventableCallback } from '~hooks/useDelayedPreventableCallback';
import { usePathname } from '~i18n/navigation';
import { useHeaderContext } from '~widgets/Header/context';

import { SideMenuContainer } from './styles';

type Props = {
	children: React.ReactNode;
};

export const Container = ({ children }: Props) => {
	const { isSideMenuOpen, headerOffset, sideMenuClose } = useHeaderContext();
	const pathname = usePathname();
	const menuRef = useRef<HTMLDivElement>(null);

	const { trigger, prevent } = useDelayedPreventableCallback({
		callback: sideMenuClose,
		delay: 3000,
	});

	useEffect(() => {
		sideMenuClose();
	}, [pathname, sideMenuClose]);

	useOnClickOutside(
		menuRef as RefObject<HTMLElement>,
		() => (isSideMenuOpen ? sideMenuClose() : undefined),
		true,
		'.ignore-click-sidemenu'
	);

	return (
		<SideMenuContainer
			ref={menuRef}
			style={
				{ '--header-offset': `${headerOffset}px` } as React.CSSProperties &
					Record<string, string | number>
			}
			isOpen={isSideMenuOpen}
			onMouseLeave={trigger}
			onMouseEnter={prevent}
		>
			{children}
		</SideMenuContainer>
	);
};
